const DEFAULT_WIDTH = 400;
const DEFAULT_HEIGHT = 560;

const openPopup = ({
  url,
  target = '_blank',
  width = DEFAULT_WIDTH,
  height = DEFAULT_HEIGHT,
}: {
  url: string;
  target?: string;
  width?: number;
  height?: number;
}) => {
  const newWindow = window.open(
    url,
    target,
    `scrollbars=yes,width=${width},height=${height},top=${
      window.outerHeight / 2 - height / 2
    },left=${window.outerWidth / 2 - width / 2}`
  );

  newWindow?.focus();

  return newWindow;
};

export default openPopup;
